<template>
  <div v-if="!loaderPrincipal
    && ((tratamientosSesion != null && tratamientosSesion .length > 0) ||
         (listaDistibucion != null && listaDistibucion .length> 0))">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <h3 tyle="padding-bottom: 10px;">
      <strong class="subcategoria">{{title}}</strong>
    </h3>

    <template v-if="tratamientosSesion != null && tratamientosSesion .length> 0">
      <div v-for="(tx, i) in tratamientosSesion" :key="'tx' + i" style="padding-bottom: 20px;">
      <b-card
          class="txSesion"
      >
        <b-row>
          <b-col class="text-left" cols="8">
            <p class="datitos">
              <b-icon v-if="tx.idKitTratamientos != null" icon="chevron-down" font-scale="1.1" v-b-toggle="tx.idKitTratamientos+'t'+i+'ind'"></b-icon>
              <strong>{{ tx.nombreTratamiento }} </strong>
            </p>

            <p class="datitos">ID: {{ tx.idTratamiento }}</p>
            <p v-if="tx.numeroDiente != null" class="datitos">
              Diente: {{ tx.numeroDiente }}
            </p>
          </b-col>
          <b-col class="text-right" cols="2">
            <p class="datitosblack" style="padding-top: 10px;">
              Saldo abonado:
              <strong>{{ tx.saldoFavor | moneda }}</strong>
            </p>
            <!--Descuento de cupon de caja(compensacion/marketing) de tipo porcentaje-->
            <p v-if="cuponSeleccionado.length > 0 && cuponSeleccionado[0].idTipoDescuentoCupon == 1 && cuponSeleccionado[0].idTipoAplicacion == 2 && tx.precioSesion > 0 && tx.descuentoPromocion == null && tx.cupon != null" class="datosPago bold" style="color: var(--color-dentalia) !important; padding-top: 10px;">
              Cupón {{ cuponSeleccionado[0].codigo }} aplicado (-{{ cuponSeleccionado[0].cantidadDescuento }}%) {{ tx.cupon | moneda }}
              <b-button
                  v-b-tooltip.hover.auto:title="'Quitar cupón'"
                  size="sm"
                  variant="ligth"
                  @click="eliminarCupon(i)"
              >
                <b-icon-x-circle
                    variant="danger"
                ></b-icon-x-circle>
              </b-button>
            </p>
            <!--Descuento de cupon de caja(compensacion/marketing) de tipo efectivo, con herramienta de cierre-->
            <p v-else-if="cuponSeleccionado.length > 0 && cuponSeleccionado[0].idTipoDescuentoCupon == 2 && cuponSeleccionado[0].idTipoAplicacion == 2 && tx.precioSesion > 0 && tx.descuentoPromocion == null && tx.cupon != null" class="datosPago bold" style="color: var(--color-dentalia) !important; padding-top: 10px;">
              Cupón {{ cuponSeleccionado[0].codigo }} aplicado {{ cuponSeleccionado[0].cantidadDescuento | moneda }}
              <b-button
                  v-b-tooltip.hover.auto:title="'Quitar cupón'"
                  size="sm"
                  variant="ligth"
                  @click="eliminarCupon(i)"
              >
                <b-icon-x-circle
                    variant="danger"
                ></b-icon-x-circle>
              </b-button>
            </p>
          </b-col>
          <b-col class="text-right" cols="2">
            <p
                class="datitos"
                style="padding-top: 8px;"
                v-if="tx.precioOriginalSesion != tx.subTotal"
            >
              Precio: {{ tx.precioOriginalSesion | moneda }}
            </p>
            <p class="datitos" v-if="tx.montoVale != null && tx.montoVale > 0" style="padding-top: 8px;">
              Descuento vale: ${{ Math.floor(tx.montoVale) }}
            </p>
            <p class="datitos" v-else-if="tx.idTipoDescuentoPlan === 1 && tx.descuento > 0" style="padding-top: 8px;">
              Descuento plan: {{ tx.descuento }}%
            </p>
            <p class="datitos" v-else-if="tx.idTipoDescuentoPlan === 2 && tx.montoDescuentoPlan > 0" style="padding-top: 8px;">
              Monto descuento plan: {{ tx.montoDescuentoPlan | moneda }}
            </p>
            <p class="datitos" v-else-if="tx.idTipoDescuentoPlan === 3 && tx.montoCopagoFijo > 0" style="padding-top: 8px;">
              Co-pago fijo: {{ tx.montoCopagoFijo | moneda }}
            </p>
            <p
                class="datitos"
                style="padding-top: 8px;"
                v-if="tx.descuentoPromocion > 0 || tx.montoPromocion > 0"
            >
              Promoción
              <span v-if="tx.descuentoPromocion > 0">{{ Math.round(tx.descuentoPromocion) }}%</span>
              <span v-else>${{ Math.round(tx.montoPromocion) }}</span>

            </p>
            <p class="datitos" style="padding-top: 8px;" v-if="cuponSeleccionado.length > 0 && cuponSeleccionado[0].idTipoAplicacion == 2 && tx.idPromocion == null && tx.precioSesion > 0 && tx.cupon != null">
              <strong v-if="tx.subTotal-tx.cupon >= 0">Total: {{ tx.subTotal-tx.cupon | moneda }}</strong>
              <strong v-else>Total: $0</strong>
            </p>
            <p class="datitos" style="padding-top: 8px;" v-else>
              <strong>Total: {{ tx.subTotal | moneda }}</strong>
            </p>
          </b-col>
        </b-row>
        <b-collapse :id="tx.idKitTratamientos+'t'+i+'ind'" accordion="my-accordion" role="tabpanel">
          <b-row class="ml-2 mr-2" style="color: gray;" v-for="(trt,indexTratamiento) in tx.listaTratamientos" :key="indexTratamiento">
            <b-col cols="1"><em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em></b-col>
            <b-col align="left"><span>{{ trt.nombreTratamiento }}</span></b-col>
          </b-row>
        </b-collapse>
      </b-card>
    </div>
    </template>

    <b-card
        v-if="listaDistibucion != null && listaDistibucion.length > 0"
        class="card-caja"
        style="height: 100%"
    >
      <div v-for="(tx, i) in listaDistibucion" :key="'txD' + i" style="padding-bottom: 20px;">
        <b-card
            class="txSesion"
        >
          <b-row>
            <b-col class="text-left" cols="6">
              <p class="datitos">
                <b-icon v-if="tx.idKitTratamientos != null" icon="chevron-down" font-scale="1.1" v-b-toggle="tx.idKitTratamientos+'t'+i+'ind'"></b-icon>
                <strong>{{ tx.nombreTratamiento }} </strong>
              </p>
              <p class="datitos">ID: {{ tx.idTratamiento }}</p>
              <p v-if="tx.numeroDiente != null" class="datitos">
                Diente: {{ tx.numeroDiente }}
              </p>
            </b-col>
            <b-col class="text-right" cols="2" style="padding-top: 10px;">
              <p class="datitosblack">
                Saldo abonado:
                <strong>{{ tx.montoDistribuido | moneda }}</strong>
              </p>
              <template v-if="descuentoPorTratamiento.length > 0">
                <div v-for="(dx, i) in descuentoPorTratamiento" :key="'DxT' + i">
                  <p v-if="cuponSeleccionado.length > 0 && cuponSeleccionado[0].idTipoDescuentoCupon == 1 && cuponSeleccionado[0].idTipoAplicacion == 2 && cuponSeleccionado[0].idTratamiento[i] == tx.idTratamiento && descuentoPorTratamiento.length > 0" class="datosPago bold" style="color: var(--color-dentalia) !important; padding-top: 10px;">
                    Cupón {{ cuponSeleccionado[0].codigo }} aplicado (-{{ cuponSeleccionado[0].cantidadDescuento }}%) {{ dx | moneda }}
                    <b-button
                        v-b-tooltip.hover.auto:title="'Quitar cupón'"
                        size="sm"
                        variant="ligth"
                        @click="eliminarCupon(i)"
                    >
                      <b-icon-x-circle
                          variant="danger"
                      ></b-icon-x-circle>
                    </b-button>
                  </p>
                  <p v-else-if="cuponSeleccionado.length > 0 && cuponSeleccionado[0].idTipoDescuentoCupon == 2 && cuponSeleccionado[0].idTipoAplicacion == 2 && cuponSeleccionado[0].idTratamiento == tx.idTratamiento && descuentoPorTratamiento.length > 0" class="datosPago bold" style="color: var(--color-dentalia) !important; padding-top: 10px;">
                    Cupón {{ cuponSeleccionado[0].codigo }} aplicado {{ dx | moneda }}
                    <b-button
                        v-b-tooltip.hover.auto:title="'Quitar cupón'"
                        size="sm"
                        variant="ligth"
                        @click="eliminarCupon(i)"
                    >
                      <b-icon-x-circle
                          variant="danger"
                      ></b-icon-x-circle>
                    </b-button>
                  </p>
                </div>
              </template>
              <template v-else-if="cuponSeleccionado.length > 0 && cuponSeleccionado[0].idTipoDescuentoCupon == 1 && cuponSeleccionado[0].idTipoAplicacion == 2 && cuponSeleccionado[0].idTratamiento == tx.idTratamiento && descuentoPorTratamiento.length == 0" class="datosPago bold" style="color: var(--color-dentalia) !important; padding-top: 10px;">
                Cupón {{ cuponSeleccionado[0].codigo }} aplicado (-{{ cuponSeleccionado[0].cantidadDescuento }}%) {{ totalCuponesM | moneda }}
                <b-button
                    v-b-tooltip.hover.auto:title="'Quitar cupón'"
                    size="sm"
                    variant="ligth"
                    @click="eliminarCupon(i)"
                >
                  <b-icon-x-circle
                      variant="danger"
                  ></b-icon-x-circle>
                </b-button>
              </template>
              <template v-else-if="cuponSeleccionado.length > 0 && cuponSeleccionado[0].idTipoDescuentoCupon == 2 && cuponSeleccionado[0].idTipoAplicacion == 2 && cuponSeleccionado[0].idTratamiento == tx.idTratamiento && descuentoPorTratamiento.length == 0" class="datosPago bold" style="color: var(--color-dentalia) !important; padding-top: 10px;">
                Cupón {{ cuponSeleccionado[0].codigo }} aplicado {{ cuponSeleccionado[0].cantidadDescuento | moneda }}
                <b-button
                    v-b-tooltip.hover.auto:title="'Quitar cupón'"
                    size="sm"
                    variant="ligth"
                    @click="eliminarCupon(i)"
                >
                  <b-icon-x-circle
                      variant="danger"
                  ></b-icon-x-circle>
                </b-button>
              </template>
            </b-col>
            <b-col class="text-right" cols="4">
              <p
                  class="datitos"
                  style="padding-top: 8px;"
                  v-if="tx.precioOriginalSesion != tx.subTotal"
              >
                Precio: {{ tx.precioOriginalSesion | moneda }}
              </p>
              <p class="datitos" v-if="tx.montoVale != null && tx.montoVale > 0" style="padding-top: 8px;">
                Descuento vale: ${{  Math.floor(tx.montoVale) }}
              </p>
              <p class="datitos" v-else-if="tx.idTipoDescuentoPlan === 1 && tx.descuento > 0" style="padding-top: 8px;">
                Descuento plan: {{ tx.descuento }}%
              </p>
              <p class="datitos" v-else-if="tx.idTipoDescuentoPlan === 2 && tx.montoDescuentoPlan > 0" style="padding-top: 8px;">
                Monto descuento plan: {{ tx.montoDescuentoPlan | moneda }}
              </p>
              <p class="datitos" v-else-if="tx.idTipoDescuentoPlan === 3 && tx.montoCopagoFijo > 0" style="padding-top: 8px;">
                Co-pago fijo: {{ tx.montoCopagoFijo | moneda }}
              </p>
              <p class="datitos" v-if="tx.montoCupon > 0 || tx.montoPromocion > 0" style="padding-top: 8px;">
                Descuento por promoción:
              </p>
              <p class="datitos" v-if="tx.montoPromocion > 0" style="padding-top: 8px;">
                Promoción -${{ Math.floor(tx.montoPromocion) }} ({{ tx.descuentoPromocion }}%) <em class="etiquetas sm"></em>
              </p>
              <p class="datitos" v-if="tx.montoCupon > 0 && tx.descuentoCupon == null" style="padding-top: 8px;">
                Cupón -${{ Math.floor(tx.montoCupon) }} <em class="cupon sm"></em>
              </p>
              <p class="datitos" v-if="tx.descuentoCupon > 0" style="padding-top: 8px;">
                Cupón -${{ Math.floor(tx.montoCupon) }} ({{ tx.descuentoCupon }}%) <em class="cupon sm"></em>
              </p>
              <p class="datitos" style="padding-top: 8px;">
                <strong>Total: {{ tx.subTotal | moneda }}</strong>
              </p>
            </b-col>
          </b-row>
          <b-collapse :id="tx.idKitTratamientos+'t'+i+'ind'" accordion="my-accordion" role="tabpanel">
            <b-table responsive
                    :items="tx.listaTratamientos"
                    :fields="fields"
                    style="text-align: center;">
                    <template v-slot:cell(nombreTratamiento)="row">
                      <em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em>
                      <span>{{ row.item.nombreTratamiento }}</span>
                    </template>
                    <template v-slot:cell(subTotal)="row">
                      {{ row.item.saldoFavor > row.item.precioSesion ? 0 : row.item.precioSesion - row.item.saldoFavor | moneda}}
                    </template>
                    <template v-slot:cell(total)="row">
                      {{ row.item.subTotal-row.item.cupon >= 0 ? row.item.subTotal - row.item.cupon : row.item.saldoFavor > row.item.precioSesion ? 0 : row.item.precioSesion - row.item.saldoFavor | moneda}}
                    </template>
                    <template v-slot:cell(montoPromocion)="row">
                      <span title="Cupón" v-if="row.item.cupon != undefined && row.item.cupon != null">{{ row.item.cupon | moneda }}</span>
                      <span title="Promoción" v-else>{{ row.item.montoPromocion | moneda}}</span>
                    </template>
                    <template v-slot:cell(montoDistribuido)="row">
                      {{ row.item.montoDistribuido | moneda}}
                    </template>
            </b-table>
          </b-collapse>
        </b-card>
      </div>
    </b-card>

    <b-card
        v-if="loaderPrincipal"
        class="card-caja"
        style="height: 100%"
    >
      <b-spinner v-if="loaderPrincipal"></b-spinner>
    </b-card>
  </div>
</template>

<script>

export default {
  name: "caja-sesion-detalle",
  components: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    fields: [
        {key: "nombreTratamiento", label: "Tratamientos"},
        {key: "subTotal", label: "Subtotal"},
        {key: "descuento", label: "Descuento plan"},
        {key: "montoPromocion", label: "Descuento promoción"},
        {key: "total", label: "Total"},
        {key: "montoDistribuido", label: "Saldo abonado"},
      ],
  }),
  props: {
    loaderPrincipal: Boolean,
    tratamientosSesion: Array,
    listaDistibucion: Array,
    descuentoPorTratamiento: Array,
    cuponSeleccionado: Array,
    title: String
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    eliminarCupon(i){
      this.$emit("eliminarCupon", i);
    }
  }
}
</script>

<style scoped>
.card-caja {
  background: #f6f6f6;
  border: none;
}

.datitos {
  font-size: small;
  padding: 0;
  margin: 0;
  color: lightslategray;
}

.datitosblack {
  font-size: small;
  padding: 0;
  margin: 0;
}

.datitos > p {
  margin-bottom: 0.5rem;
}

.datosPago{
  font-size: medium;
  padding: 0;
  margin: 0;
  color: lightslategray;
}

.txSesion > .card-body {
  padding: 0.5rem;
}
.txSesion{
  border-radius: 10px;
  border-color: #17A2B8;
}

.titulo{
  font-size: large;
}
</style>
